/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.22.0
 */

import moment from 'moment';

import { EConnectionStatusId } from '@/main/pages/PageAccountInfo/types/pageAccountInfoGeneralTypes';
import { EFormatData } from '@/main/pages/PageDashboard/types/widgetTypes';
import { EBadgeStatus } from '@components/common/Badge/BadgeStatus';
import { stringFormatParams } from '@utils/stringFormat';

import type { IConnectionStatus } from '../../internationalization/types/modules/edmOperatorConnection';

export const setStatusBadgeType = (
  statusId: EConnectionStatusId | undefined,
): EBadgeStatus => {
  const statuses = {
    [EConnectionStatusId.CONNECTED]: EBadgeStatus.active,
    [EConnectionStatusId.DISCONNECT_IN_PROGRESS]: EBadgeStatus.blocked,
    default: EBadgeStatus.future,
  };

  return statusId ? statuses[statusId] : statuses.default;
};

export const setStatusName = (
  statusId: EConnectionStatusId | undefined,
  translation: IConnectionStatus,
): string => {
  const statusNames = {
    [EConnectionStatusId.CONNECTED]: translation.statusConnected,
    [EConnectionStatusId.DISCONNECT_IN_PROGRESS]:
      translation.statusDisconnectInProgress,
    default: translation.statusConnectionInProgress,
  };

  return statusId ? statusNames[statusId] : statusNames.default;
};

type TSetStatusData = (
  statusId: EConnectionStatusId | undefined,
  statusName: string,
  statusDate: string | undefined,
  creationDate: string | undefined,
  translation: IConnectionStatus,
) => string;

export const setStatusData: TSetStatusData = (
  statusId,
  statusName,
  statusDate,
  creationDate,
  translation,
) => {
  if (statusId === EConnectionStatusId.CONNECTION_IN_PROGRESS) {
    return stringFormatParams(translation.statusData, {
      statusName,
      statusDate: statusDate
        ? moment(statusDate).format(EFormatData.FullData)
        : '-',
      creationDate: creationDate
        ? moment(creationDate).format(EFormatData.FullData)
        : '-',
    });
  } else {
    return stringFormatParams(translation.statusDataConnected, {
      statusName,
      statusDate: statusDate
        ? moment(statusDate).format(EFormatData.FullData)
        : '-',
    });
  }
};
